/* link-rewrite.js  — no <script> tags here */
(function () {
  // Determine current site's brand: SLD + TLD (e.g., lasercutsupply + com)
  function getBase(host) {
    if (!host) return null;
    var clean = host.toLowerCase().replace(/^www\./, '');
    var parts = clean.split('.').filter(Boolean);
    if (parts.length < 2) return null;
    return { sld: parts[parts.length - 2], tld: parts[parts.length - 1] };
  }

  // Only care about http(s) or protocol-relative URLs
  function isHttpLike(href) {
    return /^https?:\/\//i.test(href) || href.startsWith('//');
  }

  function abs(href) {
    return href.startsWith('//') ? (location.protocol + href) : href;
  }

  var current = getBase(location.hostname);
  if (!current) return;

  function rewriteAnchor(a) {
    var raw = a.getAttribute('href') || '';
    if (!raw) return false;

    // Skip anchors, mailto, tel, javascript:
    if (raw[0] === '#' || /^mailto:|^tel:|^javascript:/i.test(raw)) return false;

    // Relative links already use the current domain
    if (!isHttpLike(raw)) return false;

    var url;
    try {
      url = new URL(abs(raw), location.origin);
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    var linkBase = getBase(url.hostname);
    if (!linkBase) return false;

    // Same brand (same SLD) but different TLD? Swap TLD to the current page's TLD.
    if (
      linkBase.sld === current.sld &&
      linkBase.tld !== current.tld
    ) {
      var hostParts = url.hostname.toLowerCase().replace(/^www\./, '').split('.');
      // Replace last label (TLD) with current TLD
      hostParts[hostParts.length - 1] = current.tld;
      url.hostname = hostParts.join('.');
      // Keep content links in the active storefront language (e.g. /fr/).
      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var contentPath = url.pathname.replace(/^\/(?:nl|en|de|fr)(?=\/)/, '');
      if (/^\/(?:products|collections|pages|blogs|policies|cart|search)(?:\/|$)/.test(contentPath)) {
        url.pathname = routeRoot.replace(/\/$/, '') + contentPath;
      }
      a.href = url.toString();
      return true;
    }
    return false;
  }

  function rewriteAll(root) {
    var changed = 0;
    (root || document).querySelectorAll('a[href]').forEach(function (a) {
      if (rewriteAnchor(a)) changed++;
    });
    return changed;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // Initial pass
    rewriteAll();

    // Watch for links injected later by apps/sections
    var obs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'href' && m.target.tagName === 'A') {
          rewriteAnchor(m.target);
        }
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'A') {
              rewriteAnchor(node);
            } else {
              rewriteAll(node);
            }
          });
        }
      });
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });

    // Manual trigger for debugging:
    window.__rewriteBrandLinks = function () { return rewriteAll(); };
  });
})();
